module.exports = __webpack_public_path__ + "static/img/zy.bc33e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zy.png
// module id = vhnd
// module chunks = 0